// client/src/pages/Register/Register.jsx
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import API_BASE_URL from "../../apiConfig"; 

export default function Register() {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [studentID, setStudentID] = useState("");
  const [workerID, setWorkerID] = useState("");
  const [error, setError] = useState("");

  const url = `${API_BASE_URL}`;

  const submit = async (event) => {
    event.preventDefault();
    const payload = {
      name: `${firstName} ${lastName}`,
      studentID,
      workerID,
    };

    try {
      await axios.post(`${url}/student/register`, payload, { withCredentials: true });
      navigate("/landing");
    } catch (err) {
      console.error(err);
      setError("Registration failed. Please try again.");
    }
  };

  return (
    <div className="register-page">
      <div className="register-container">
        <h1 className="register-title">Register</h1>
        <form onSubmit={submit}>
          <div className="input-group">
            <label htmlFor="FirstName">First Name</label>
            <input
              id="FirstName"
              autoComplete="off"
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="LastName">Last Name</label>
            <input
              id="LastName"
              autoComplete="off"
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="StudentID">Student ID</label>
            <input
              id="StudentID"
              type="text"
              autoComplete="off"
              placeholder="Student ID"
              value={studentID}
              onChange={(e) => setStudentID(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="WorkerID">Worker ID</label>
            <input
              id="WorkerID"
              type="text"
              autoComplete="off"
              placeholder="Worker ID"
              value={workerID}
              onChange={(e) => setWorkerID(e.target.value)}
              required
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button className="submit-btn" type="submit">
            Register
          </button>
        </form>
        <div className="note-box">
          <p className="note-text">
            Note: The student fills out the first three fields, and the Student Worker fills out the last one.
          </p>
        </div>
      </div>
    </div>
  );
}